module.exports = __webpack_public_path__ + "media/tip.5ea074b6.mp3";